import {
  Box,
  FormControl as FC,
  Flex,
  FormHelperText,
  FormLabel,
  Spinner,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import ErrorMessage from '@components/ErrorMessage';
import { IFormControl } from '@components/FormControl/FormControl.types';

const FormControl: React.FC<IFormControl> = ({
  label,
  sublabel,
  help,
  extra,
  children,
  isOptional,
  colorExtra = 'text.muted',
  sizeExtra,
  isRequired,
  isLoading,
  isRow,
  isDetail,
  ...props
}): JSX.Element => {
  return (
    <FC
      {...(isRow && {
        display: 'grid',
        gridTemplateColumns: '150px 1fr',
      })}
      {...props}
    >
      <FormLabel
        {...(!label && { mb: '0' })}
        {...(isRow && {
          mb: '0',
          mt: isDetail ? '0' : '2',
        })}
      >
        <Flex align="center" w="full">
          {label}
          {isOptional && (
            <Text
              as="span"
              fontSize="xs"
              color="text.muted"
              fontWeight="normal"
              ml="1"
            >
              (opsional)
            </Text>
          )}
          {isRequired && (
            <Text
              as="span"
              fontSize="xs"
              color="text.error"
              fontWeight="normal"
            >
              *
            </Text>
          )}
          {isLoading && <Spinner size="xs" ml="2" />}
          {isDetail && (
            <Text
              color={{ base: 'red', md: 'white' }}
              ml="auto"
              justifySelf="flex-end"
            >
              :
            </Text>
          )}
        </Flex>
        {sublabel && (
          <Text fontSize="xs" color="text.muted" fontWeight="normal">
            {sublabel}
          </Text>
        )}
      </FormLabel>
      <Box flex="1">
        {children}
        {extra && (
          <FormHelperText color={colorExtra} fontSize={sizeExtra}>
            {extra}
          </FormHelperText>
        )}
        {help && <ErrorMessage message={String(help)} />}
      </Box>
    </FC>
  );
};

export default FormControl;
